import { onScopeDispose } from 'vue';
import { isBrowser } from '@nzyme/dom-utils/isBrowser.js';
/** Adds a window event listener that auto-removes on scope disposal. */
export function onWindowEvent(type, listener, options) {
    if (!isBrowser()) {
        return;
    }
    window.addEventListener(type, listener, options);
    onScopeDispose(() => {
        window.removeEventListener(type, listener, options);
    });
}
//# sourceMappingURL=onWindowEvent.js.map